import staticDataStore from './staticData.store'
import UserStore from './user.store'
import Modal from './modal.store'
import ActiveProjectsStore from './ActiveProjects.store'
import AtheneumContactStore from './AtheneumContact.store'
import ProjectStore from './Project.store'

import ComplianceAuditStore from './ComplianceAudit.store'
import GrowlStore from './Growl.store'
import NotificationStore from './Notification.store'
import socketIOClient from 'socket.io-client'

export const socket = socketIOClient.connect({
  transports: ['websocket'],
})

const growlStore = new GrowlStore()
const notificationStore = new NotificationStore(growlStore)
const userStore = new UserStore(socket, notificationStore)
const modalStore = new Modal()
const atheneumContactStore = new AtheneumContactStore()
const projectStore = new ProjectStore(staticDataStore)

const complianceAuditStore = new ComplianceAuditStore(staticDataStore)
const activeProjectsStore = new ActiveProjectsStore(growlStore)

const stores = {
  staticDataStore,
  userStore,
  modalStore,
  activeProjectsStore,
  complianceAuditStore,
  growlStore,
  notificationStore,
  atheneumContactStore,
  projectStore,
}

window.stores = stores

export { stores }
